import styled from 'styled-components'

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: ${props => props.theme.spacing.sp40};

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
